import { defineComponent as _defineComponent } from 'vue'
import api from '@/api';
import moment from 'moment';
import { computed, ref, nextTick } from 'vue';
import WidgetForm from '@/components/WidgetForm/WidgetForm.vue';
import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';
import { getStepIconClass } from '@/components/TaskLog/TaskLogService.js';
import { InterfaceLogDetails } from '@/components/InterfacesLogs/interfaces-logs-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'InterfaceLog',
  props: {
    interfaceLogDetails: null
  },
  setup(__props: any) {

const props = __props as {
	interfaceLogDetails: InterfaceLogDetails;
}



const widgetRef = ref<InstanceType<typeof WidgetForm> | null>(null);
const stepIconClass = computed(() => getStepIconClass(props.interfaceLogDetails.run.status));
const submissionDate = computed(() => moment(props.interfaceLogDetails.run.modified).format('MMMM Do YYYY, hh:mm:ss'));
const isEndRun = computed(() => props.interfaceLogDetails.run.serviceSlug === ServiceSlugs.EndRun);
const testResponseNotFlattened = computed(() => props.interfaceLogDetails.output.output);
const editedTestResponse = computed(() => {
	const res: Record<string, unknown> = {};
	const testResponses = testResponseNotFlattened.value.values || {};
	Object.keys(testResponses).forEach((key) => {
		if (key && key !== 'null') {
			res[`values.${key}`] = testResponses[key];
		}
	});
	return res;
});
const widget = computed(() => props.interfaceLogDetails.definition);
const previousSteps = computed(() => props.interfaceLogDetails.output.previousSteps);

const setWidget = () => {
	widgetRef.value?.setWidget({
		isEndRun: isEndRun.value,
		api: { queryAC: api.queryAC, getWidgetFieldUploadUrl: api.getWidgetFieldUploadUrl },
		widget: { ...widget.value, previousSteps: previousSteps.value, replaceInsertDataStringDict: {}, configurationsMappingBlocksUUIDs: [] },
	});
};
nextTick(() => {
	setWidget();
});

return { __sfc: true,props, widgetRef, stepIconClass, submissionDate, isEndRun, testResponseNotFlattened, editedTestResponse, widget, previousSteps, setWidget, WidgetForm }
}

})